import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ApiAcceptInvite, ApiGetInviteInfo } from '@/api';
import useLocale from '@/utils/useLocale';
import validPassword from '@/utils/validPassword';
import locale from './locale';
import styles from './style/index.module.less';
const FormItem = _Form.Item;
const {
  Text
} = _Typography;

// 后端 parseTime=true 时 timestamp 会序列化为 RFC3339, 这里只保留 YYYY-MM-DD HH:mm:ss
function formatTime(value) {
  if (!value) {
    return '-';
  }

  const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/.exec(value);
  return match ? `${match[1]} ${match[2]}` : value;
}

const Invite = () => {
  const t = useLocale(locale);
  const history = useHistory();

  const [form] = _Form.useForm(); // 邮件里的邀请链接: https://msp.connetworks.com/invite?token=<token>


  const [token] = useState(() => new URLSearchParams(window.location.search).get('token') || '');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(''); // 凭 token 从后端获取团队名称/ID 与邮箱

  useEffect(() => {
    if (!token) {
      setError(t['invite.error.token']);
      setLoading(false);
      return;
    }

    ApiGetInviteInfo({
      token
    }).then(req => {
      const data = req.data.data;

      if (req.data.code === 0 && data) {
        setInfo(data);
      } else {
        setError(req.data.message || t['invite.error.token']);
      }
    }).catch(() => {
      setError(t['invite.error.failed']);
    }).finally(() => {
      setLoading(false);
    });
  }, [token, t]); // 邀请详情到位后回填只读邮箱 (FormItem 会注入 value, 不能直接给 Input 传 value)

  useEffect(() => {
    if (info) {
      form.setFieldsValue({
        email: info.email
      });
    }
  }, [info, form]); // 设置完密码 -> 创建用户并加入团队

  function handleSubmit() {
    form.validate().then(values => {
      setSubmitting(true);
      ApiAcceptInvite({
        token,
        password: values.password,
        username: (values.username || '').trim()
      }).then(req => {
        if (req.data.code === 0) {
          const joined = req.data.data && req.data.data.joined;

          _Message.success(joined ? t['invite.success.joined'] : t['invite.success']);

          window.setTimeout(() => history.push('/login'), 800);
        } else {
          _Message.error(req.data.message || t['invite.failed']);
        }
      }).catch(() => {
        _Message.error(t['invite.failed']);
      }).finally(() => {
        setSubmitting(false);
      });
    }).catch(() => {// 校验失败, 由 FormItem 展示
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['auth-root']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['form-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-wrap']
  }, loading ? /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '40px 0'
    }
  }, /*#__PURE__*/React.createElement(_Spin, {
    tip: t['invite.loading']
  })) : error ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Typography.Title, {
    heading: 5,
    style: {
      marginBottom: 12
    }
  }, t['invite.error.title']), /*#__PURE__*/React.createElement(Text, {
    type: "secondary"
  }, error), /*#__PURE__*/React.createElement(_Button, {
    style: {
      height: 40,
      marginTop: 24
    },
    type: "primary",
    long: true,
    onClick: () => history.push('/login')
  }, t['invite.back'])) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Typography.Title, {
    heading: 4,
    style: {
      marginBottom: 2
    }
  }, t['invite.title.welcome']), /*#__PURE__*/React.createElement(_Typography.Title, {
    heading: 4
  }, info?.team_name || t['invite.title.team']), /*#__PURE__*/React.createElement(Text, {
    type: "secondary",
    style: {
      display: 'block',
      marginBottom: 20
    }
  }, (info?.inviter ? t['invite.description'].replace('{inviter}', info.inviter) : t['invite.description.noInviter']).replace('{team}', info?.team_name || ''), info?.expired_at ? ` ${t['invite.expired'].replace('{time}', formatTime(info.expired_at))}` : ''), /*#__PURE__*/React.createElement(_Form, {
    form: form,
    layout: "vertical",
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(FormItem, {
    label: t['invite.email'],
    field: "email"
  }, /*#__PURE__*/React.createElement(_Input, {
    height: 40,
    disabled: true
  })), /*#__PURE__*/React.createElement(FormItem, {
    label: t['invite.username'],
    field: "username",
    rules: [{
      maxLength: 45,
      message: t['invite.username.max']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    height: 40,
    maxLength: 45,
    placeholder: t['invite.username.placeholder']
  })), /*#__PURE__*/React.createElement(FormItem, {
    label: t['invite.password'],
    field: "password",
    validateTrigger: "onBlur",
    rules: [{
      required: true,
      message: t['invite.password.required']
    }, {
      validator: (value, callback) => {
        if (value && validPassword(value)) {
          return callback(t['invite.password.invalid']);
        }

        callback(null);
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    height: 40,
    placeholder: t['invite.password.placeholder']
  })), /*#__PURE__*/React.createElement(FormItem, {
    label: t['invite.password.confirm'],
    field: "confirmPassword",
    validateTrigger: "onBlur",
    dependencies: ['password'],
    rules: [{
      required: true,
      message: t['invite.password.confirm.required']
    }, {
      validator: (value, callback) => {
        if (value !== form.getFieldValue('password')) {
          return callback(t['invite.password.confirm.mismatch']);
        }

        callback(null);
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    height: 40,
    placeholder: t['invite.password.confirm.placeholder']
  })), /*#__PURE__*/React.createElement(FormItem, null, /*#__PURE__*/React.createElement(_Space, {
    direction: "vertical",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    style: {
      height: 40
    },
    type: "primary",
    long: true,
    loading: submitting,
    onClick: handleSubmit
  }, submitting ? t['invite.submit.loading'] : t['invite.submit']), /*#__PURE__*/React.createElement(_Button, {
    style: {
      height: 40
    },
    type: "outline",
    long: true,
    onClick: () => history.push('/login')
  }, t['invite.back']))))))))));
};

export default Invite;